import _parseInt from 'lodash/parseInt';
import _toFinite from 'lodash/toFinite';
import APPCONFIG from '../../../constants/Config';
import {
  REINIT_STATE,
  CPM_ADD_CARPARK_BOOKING,
  CPM_CANCEL_CARPARK_BOOKING,
  CPM_GET_CARPARK_BOOKINGS_LIST,
  CPM_GET_ONEPARK_BOOKINGS_LIST,
  CPM_SEARCH_CARPARK_BOOKING_OFFER,
  CPM_UPDATE_CARPARK_BOOKING,
  CPM_UPDATE_CARPARK_BOOKING_STATE,
  CPM_SEND_BOOKING_PAYMENT_LINK,
  CPM_REFUND_BOOKING,
  CPM_RESEND_BOOKING_CONFIRMATION_EMAIL,
} from '../../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserializeBooking, deserializeBookingOnepark } from '../../../models/cpm/booking';
import { deserializeOffer } from '../../../models/cpm/finance';
import { deserialize as deserializeOperation } from '../../../models/cpm/synchronization';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.cpmCarparkBooking;
const cpmCarparkBooking = (state = initialSettings, action) => {
  let key;
  let mutationResult;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullCarpark' || action.target === 'currentCarpark') {
        return {
          ...state,
          list: { ...initialSettings.list },
          add: { ...initialSettings.add },
          cancel: { ...initialSettings.cancel },
          search: { ...initialSettings.search },
          update: { ...initialSettings.update },
          refund: { ...initialSettings.refund },
          sendPaymentLink: { ...initialSettings.sendPaymentLink },
          resendBookingConfirmationEmail: { ...initialSettings.resendBookingConfirmationEmail },
        };
      }
      switch (action.target) {
        case 'addCarparkBooking':
          key = 'add';
          break;
        case 'cancelCarparkBooking':
          key = 'cancel';
          break;
        case 'searchCarparkBookingOffer':
          key = 'search';
          break;
        case 'updateCarparkBooking':
          key = 'update';
          break;
        case 'sendBookingPaymentLink':
          key = 'sendPaymentLink';
          break;
        case 'refundBooking':
          key = 'refund';
          break;
        case 'resendBookingConfirmationEmail':
          key = 'resendBookingConfirmationEmail';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // LIST
    case CPM_GET_CARPARK_BOOKINGS_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          error: null,
          loading: true,
          elements: {
            ...state.list.elements,
            data: null,
          },
        },
      };
    case `${CPM_GET_CARPARK_BOOKINGS_LIST}_ERROR`:
      return {
        ...state,
        list: {
          ...state.list,
          error: action.error,
          loading: false,
        },
      };
    case `${CPM_GET_CARPARK_BOOKINGS_LIST}_SUCCESS`:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          elements: {
            ...state.list.elements,
            data: deserializeBooking(action.data.listBookings.entries),
            pageNumber: _parseInt(action.data.listBookings.pageNumber),
            pageSize: _parseInt(action.data.listBookings.pageSize),
            totalEntries: _parseInt(action.data.listBookings.totalEntries),
            totalPages: _parseInt(action.data.listBookings.totalPages),
          },
        },
      };
    // LIST ONEPARK BOOKING
    case CPM_GET_ONEPARK_BOOKINGS_LIST:
      return {
        ...state,
        listOnepark: {
          ...state.listOnepark,
          error: null,
          loading: true,
          elements: {
            ...state.listOnepark.elements,
            data: null,
          },
        },
      };
    case `${CPM_GET_ONEPARK_BOOKINGS_LIST}_ERROR`:
      return {
        ...state,
        listOnepark: {
          ...state.listOnepark,
          error: action.error,
          loading: false,
        },
      };
    case `${CPM_GET_ONEPARK_BOOKINGS_LIST}_SUCCESS`:
      return {
        ...state,
        listOnepark: {
          ...state.listOnepark,
          loading: false,
          elements: {
            ...state.listOnepark.elements,
            data: deserializeBookingOnepark(action.data.listOneparkBookings.entries),
            pageNumber: _parseInt(action.data.listOneparkBookings.pageNumber),
            pageSize: _parseInt(action.data.listOneparkBookings.pageSize),
            totalEntries: _parseInt(action.data.listOneparkBookings.totalEntries),
            totalPages: _parseInt(action.data.listOneparkBookings.totalPages),
          },
        },
      };
    // GENERATE OFFER
    case CPM_SEARCH_CARPARK_BOOKING_OFFER:
      return {
        ...state,
        search: {
          ...state.search,
          error: null,
          loading: true,
          result: null,
        },
      };
    case `${CPM_SEARCH_CARPARK_BOOKING_OFFER}_ERROR`:
      return {
        ...state,
        search: {
          ...state.search,
          error: action.error,
          loading: false,
        },
      };
    case `${CPM_SEARCH_CARPARK_BOOKING_OFFER}_SUCCESS`:
      return {
        ...state,
        search: {
          ...state.search,
          loading: false,
          result: deserializeOffer(action.data.search),
        },
      };
    // ADD CARPARK BOOKING
    case CPM_ADD_CARPARK_BOOKING:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_ADD_CARPARK_BOOKING}_ERROR`:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case `${CPM_ADD_CARPARK_BOOKING}_SUCCESS`:
      mutationResult = action.data.addBooking;
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
          result: {
            purchase: mutationResult.purchases[0],
          },
          type: action.parkingType,
        },
      };
    // UPDATE CARPARK BOOKING
    case CPM_UPDATE_CARPARK_BOOKING:
    case CPM_UPDATE_CARPARK_BOOKING_STATE:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_UPDATE_CARPARK_BOOKING}_ERROR`:
    case `${CPM_UPDATE_CARPARK_BOOKING_STATE}_ERROR`:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case `${CPM_UPDATE_CARPARK_BOOKING}_SUCCESS`:
      mutationResult = action.data.updateBooking;
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
          result: {
            ...mutationResult,
            id: _toFinite(mutationResult.id),
            operation: deserializeOperation(mutationResult.operation),
          },
          type: action.parkingType,
        },
      };
    case `${CPM_UPDATE_CARPARK_BOOKING_STATE}_SUCCESS`:
      mutationResult = action.data.updateBookingState;
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
          result: {
            ...mutationResult,
            id: _toFinite(mutationResult.id),
            operation: deserializeOperation(mutationResult.operation),
          },
        },
      };

    // SEND BOOKING PAYMENT LINK
    case CPM_SEND_BOOKING_PAYMENT_LINK:
      return {
        ...state,
        sendPaymentLink: {
          ...state.sendPaymentLink,
          error: null,
          loading: true,
          result: null,
        },
      };

    case `${CPM_SEND_BOOKING_PAYMENT_LINK}_SUCCESS`:
      return {
        ...state,
        sendPaymentLink: {
          ...state.sendPaymentLink,
          loading: false,
          result: action.data.sendBookingPaymentLink,
        },
      };

    case `${CPM_SEND_BOOKING_PAYMENT_LINK}_ERROR`:
      return {
        ...state,
        sendPaymentLink: {
          ...state.sendPaymentLink,
          error: action.error,
          loading: false,
        },
      };

    // REFUND BOOKING
    case CPM_REFUND_BOOKING:
      return {
        ...state,
        refund: {
          ...state.refund,
          error: null,
          loading: true,
          refunded: false,
        },
      };

    case `${CPM_REFUND_BOOKING}_SUCCESS`:
      return {
        ...state,
        refund: {
          ...state.refund,
          loading: false,
          refunded: true,
          error: null,
        },
      };

    case `${CPM_REFUND_BOOKING}_ERROR`:
      return {
        ...state,
        refund: {
          ...state.refund,
          refunded: false,
          error: action.error,
          loading: false,
        },
      };

    // RESEND CONFIRMATION EMAIL
    case CPM_RESEND_BOOKING_CONFIRMATION_EMAIL:
      return {
        ...state,
        resendBookingConfirmationEmail: {
          ...state.resendBookingConfirmationEmail,
          error: null,
          loading: true,
          result: null,
        },
      };

    case `${CPM_RESEND_BOOKING_CONFIRMATION_EMAIL}_SUCCESS`:
      return {
        ...state,
        resendBookingConfirmationEmail: {
          ...state.resendBookingConfirmationEmail,
          loading: false,
          result: action.data.resendBookingConfirmationEmail,
        },
      };

    case `${CPM_RESEND_BOOKING_CONFIRMATION_EMAIL}_ERROR`:
      return {
        ...state,
        resendBookingConfirmationEmail: {
          ...state.resendBookingConfirmationEmail,
          error: action.error,
          loading: false,
        },
      };
    // CANCEL CARPARK BOOKING
    case CPM_CANCEL_CARPARK_BOOKING:
      return {
        ...state,
        cancel: {
          ...state.cancel,
          cancelled: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_CANCEL_CARPARK_BOOKING}_ERROR`:
      return {
        ...state,
        cancel: {
          ...state.cancel,
          error: action.error,
        },
      };
    case `${CPM_CANCEL_CARPARK_BOOKING}_SUCCESS`:
      mutationResult = action.data.cancelBooking;
      return {
        ...state,
        cancel: {
          ...state.cancel,
          cancelled: true,
          result: {
            ...mutationResult,
            id: _toFinite(mutationResult.id),
          },
        },
      };
    default:
      return state;
  }
};

export default cpmCarparkBooking;



// WEBPACK FOOTER //
// ./reducers/cpm/carpark/carparkBooking.js